export default __webpack_public_path__ + "static/media/blogBackground.0e2f2c67.jpeg";